/* eslint-disable react/jsx-no-target-blank */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { getSidebarRouteConfig, SIDEBAR } from "../../../../helpers/RouterHelpers";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../redux/types";
import { useLocation } from 'react-router-dom';
const SidebarMenuMain = () => {
	const location = useLocation();
	let allSidebar = getSidebarRouteConfig();
	const navigation = useSelector((state: AppState)=>state.navigation)
	const [superadminLogin, setSuperAdminLogin]=useState(localStorage.getItem('super-admin'))
	const [sidebar, setSidebar]=useState([])

	// let backend = ['user_role_management', 'home', 'user_management', 'role_management', 'wallet','wallet_view_details'];
	function generateSubMenu(subMenu) {
		let subMenuJsx = subMenu.map((item) => {
			const matchingSubSidebar = allSidebar.find((subSidebarMenu) => subSidebarMenu._name === item._name);

			if (matchingSubSidebar) {
				return <SidebarMenuItem key={matchingSubSidebar._name} to={matchingSubSidebar.link} title={matchingSubSidebar.lebel} hasBullet={true} />;
			}

			return null;
		});

		return subMenuJsx;
	}

useEffect(()=>{

	if(superadminLogin == "1"){
		setSidebar(SIDEBAR)
	}else{
	let dynamicSidebarMenu = []
	 navigation.map((_)=>{
		
		if(_?.menu_name){
			dynamicSidebarMenu .push( _?.menu_name?.toLowerCase())
		}

		_.submenu.forEach((item)=>{
			if(item.is_check && item.menu_name){
				dynamicSidebarMenu.push( item?.menu_name?.toLowerCase())
			}
		})
	})

	function generateSideBar(menuItems: any, backendMenu: any) {
		let tempMenu = [];
		for (let i = 0; i < menuItems.length; i++) {
			let _menu = menuItems[i];
			let config = { _name: '', sub: null };
			if (_menu?._name && backendMenu.includes(_menu._name)) {
				config._name = _menu._name;
				if (_menu.sub) {

					//console.log(_menu)
					let checkSubSideBar = _menu.sub.find((_subMenu) => dynamicSidebarMenu.includes(_subMenu._name));
					if (checkSubSideBar) {
						let filteredSub = generateSideBar(_menu.sub, backendMenu);
						if (filteredSub.length > 0) {
							config.sub = filteredSub;
							config._name = _menu._name;
							tempMenu.push(config);
						}
					}
				} else {
					tempMenu.push(config);
				}
			}
		}
		return tempMenu
	}
	setSidebar(generateSideBar(SIDEBAR, dynamicSidebarMenu ));	
}
},[navigation])

	// To restict the unotharized access by user
	
	// let authorizedUrl = false;
	// const urls = allSidebar.find((subSidebarMenu) => subSidebarMenu.link === location.pathname);
	// navigation.map((_) => {
	// 	if (_?.menu_name === urls._name) {
	// 		authorizedUrl = true;
	// 	}
	// 	_.submenu.forEach((item) => {
	// 		if (item?.menu_name === urls._name) {
	// 			authorizedUrl = true;
	// 		}
	// 	})
	// });
	// if (!authorizedUrl) {

	// }

	return (
		<>
			{sidebar.map((constant) => {
				const matchingSidebar = allSidebar.find((currentSidebar) => currentSidebar._name === constant._name);

				if (!matchingSidebar) return null;

				if (matchingSidebar) {
					if (Array.isArray(constant.sub)) {
						let _sub = generateSubMenu(constant.sub);

						return (
							<React.Fragment key={matchingSidebar._name}>
								<SidebarMenuItemWithSub to={matchingSidebar.link} title={matchingSidebar.lebel} icon={matchingSidebar.icon} fontIcon={matchingSidebar.fi}>
									{_sub}
								</SidebarMenuItemWithSub>
							</React.Fragment>
						);
					} else {
						return (
							<React.Fragment key={matchingSidebar._name}>
								<SidebarMenuItem to={matchingSidebar.link} icon={matchingSidebar.icon} title={matchingSidebar.lebel} fontIcon={matchingSidebar.fi} />
							</React.Fragment>
						);
					}
				}
			})}
		</>
	);
};

export { SidebarMenuMain };
